import { ActionTypes } from '../actions';

export const INITIAL_STATE = {
  name: '',
  email: null,
  userType: null,
  authError: false,
  authSuccess: false,
  matchFailed: false,
  emailSent: false,
  authenticated: false,
  answers: {},
  loadingUserData: true,
  profileOpen: false,
};

const UserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_USER:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.AUTH_SUCCESS:
      return {
        ...state,
        authSuccess: true,
      };
    case ActionTypes.RESEND_SUCCESS:
      return {
        ...state,
        emailSent: true,
      };
    case ActionTypes.AUTH_ERROR:
      return {
        ...state,
        authError: true,
      };
    case ActionTypes.CLEAR_USER_STATUSES:
      return {
        ...state,
        authError: false,
        authSuccess: false,
        emailSent: false,
      };
    case ActionTypes.CLEAR_EMAIL_SENT:
      return {
        ...state,
        emailSent: false,
        authError: false,
      };
    case ActionTypes.SWITCH_USER_TYPE:
      return {
        ...state,
        answers: {},
        userType: action.payload.userType,
      };
    case ActionTypes.UPDATE_PROFILE_PHOTO:
      return {
        ...state,
        answers: {
          ...state.answers,
          profile_photo: {
            ...state.answers.profile_photo,
            answer: action.payload,
          },
        },
      };
    case ActionTypes.DEAUTH_USER:
      return {
        ...INITIAL_STATE,
        loadingUserData: false,
      };
    default:
      return state;
  }
};

export default UserReducer;
